import LottieWeb from 'react-native-web-lottie';
export default LottieWeb;
